// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import { PAGE_FINANCE, PAGE_PROFILE, PAGE_QUOTE, PAGE_STORE, PAGE_SUPPORT, REGISTRATION_STATE_APPROVED, REGISTRATION_STATE_SUSPENDED } from '../../common/constants';
import { setUserMobileAuthToken, setUserParameters } from '../../redux/actions/authentication';
import { getSlimAssociateData } from '../../redux/actions/profile';
import AuthenticationService from '../../redux/services/authentication';

class MobileAuthenticationProxyPage extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        let userParameters = this.getProxyParameters();
    }

    getProxyParameters() {
        let search = window.location.search;
        let params = new URLSearchParams(search);

        if(this.validateProxyParameters(params)) {
            let pageParameter = params.get('page');
            let tokenParameter = params.get('token');

            let userParameters = window.atob(tokenParameter).split(',');

            if(tokenParameter === null) {
                localStorage.setItem('Hideinapp', '1');

                // Proxy to the provided page
                this.proxyApplicationPage(pageParameter);
            }
            else {
                AuthenticationService.validateUserData(userParameters)
                    .then((response) => {
                        if(response.validationResult === true) {
        
                            // Store auth token for future usage
                            if(this.props.mobileAuthToken === null && tokenParameter !== null) {
                                this.props.setUserMobileAuthToken(tokenParameter);
                            }     
        
                            this.props.setUserParameters(userParameters[0], userParameters[1], userParameters[2], response.registrationState === REGISTRATION_STATE_APPROVED, response.registrationState, response.mbPending, response.mbwayPending, response.organicUnits, response.brainAnswerAccess, response.hasSignatureCredits, response.internal);
                            this.props.getSlimAssociateData(userParameters[2]);
        
                            // Hide header and footer on mobile view
                            localStorage.setItem('Hideinapp', '1');
        
                            setTimeout(() => {
                                // Proxy to the provided page
                                this.proxyApplicationPage(pageParameter);
                            }, 1000);
                        }
                        else {
                            window.open(process.env.REACT_APP_MOBILE_LOGOUT_URL, "_self");
                        }
                    })
                    .catch(error => {
                        window.open(process.env.REACT_APP_MOBILE_LOGOUT_URL, "_self");
                    });
                }
        }
        else {
            window.open(process.env.REACT_APP_MOBILE_LOGOUT_URL, "_self");
        }
    }

    validateProxyParameters(params) {
        if(params === null) return false;

        let pageParameter = params.get('page');
        let tokenParameter = params.get('token');

        if(pageParameter === null || pageParameter === "") return false;

        if(this.props.mobileAuthToken !== null) return true;

        return (tokenParameter !== null);
    }

    proxyApplicationPage(page) {
        switch (page) {
            case PAGE_PROFILE:
                window.open(process.env.PUBLIC_URL + "/profile", "_self");
                break;
            
            case PAGE_FINANCE:
                window.open(process.env.PUBLIC_URL + "/payments", "_self");
                break;
            
            case PAGE_QUOTE:
                window.open(process.env.PUBLIC_URL + "/quotes", "_self");
                break;

            case PAGE_STORE:
                window.open(process.env.PUBLIC_URL + "/products", "_self");
                break;

            case PAGE_SUPPORT:
                window.open(process.env.PUBLIC_URL + "/support", "_self");
                break;

            default:
                window.open(process.env.REACT_APP_MOBILE_LOGOUT_URL, "_self");
                break;
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        mobileAuthToken: state.authentication.mobileAuthToken
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setUserParameters: (userId, formId, registrationRef, registrationApproved, registrationState, mbPending, mbwayPending, organicUnit, brainAnswerAccess, hasSignatureCredits, internal) => { dispatch(setUserParameters(userId, formId, registrationRef, registrationApproved, registrationState, mbPending, mbwayPending, organicUnit, brainAnswerAccess, hasSignatureCredits, internal)) },
        getSlimAssociateData: (registrationRef) => { dispatch(getSlimAssociateData(registrationRef)) },
        setUserMobileAuthToken: (mobileAuthToken) => { dispatch(setUserMobileAuthToken(mobileAuthToken)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(MobileAuthenticationProxyPage));